import React from 'react'
import { useLanguage } from '~components'
import { BottomBar, BottomText, BottomBtn } from '../HomeHero/styles'
import {
  PolicyContainer,
  PageHeader,
  PageTitle,
  PageSubtitle,
  TopDivider,
  BottomDivider,
  ContentContainer,
  Section,
  SectionTitle,
  SectionText,
  HighlightText,
  NormalText,
  BulletList,
  BulletItem,
  BackgroundWatermark
} from './styles'

import logoIcon from '../../../../assets/images/newimage/logo.svg'

// Reusable structural component for privacy sections
const PolicySection = ({ title, highlightDesc, normalDesc, desc, items, children }) => (
  <Section>
    <SectionTitle>{title}</SectionTitle>
    {highlightDesc && (
      <SectionText>
        <HighlightText>{highlightDesc}</HighlightText>{' '}
        <NormalText>{normalDesc}</NormalText>
      </SectionText>
    )}
    {desc && (
      <SectionText>
        <NormalText>{desc}</NormalText>
      </SectionText>
    )}
    {children}
    {items && (
      <BulletList>
        {items.map((item, i) => (
          <BulletItem key={i}>{item}</BulletItem>
        ))}
      </BulletList>
    )}
  </Section>
)

export const TermsAndConditions = (props) => {
  const [, t] = useLanguage()

  return (
    <PolicyContainer>
      <PageHeader>
        <PageTitle>{t('TERMS_AND_CONDITIONS', 'TERMS & CONDITIONS')}</PageTitle>
        <PageSubtitle>{t('TERMS_AND_CONDITIONS_SUBTITLE', 'Please review to terms governing the use of Bottle Bottle Runners services.')}</PageSubtitle>
      </PageHeader>

      <TopDivider />

      <ContentContainer>
        <BackgroundWatermark img={logoIcon} />

        <PolicySection
          title={`1. ${t('LEGAL_AGE_REQUIREMENT', 'LEGAL AGE REQUIREMENT:')}`}
        >
          <SectionText>
            <NormalText>{t('USERS_MUST_19_OR', 'Users must 19+ (or')}</NormalText>{' '}
            <HighlightText>{t('LEGAL_DRINKING_AGE_DESC', 'legal drioing drinking age')}</HighlightText>{' '}
            <NormalText>{t('USERS_MUST_19_OR_CONT', 'in their province) to their service. ID verification mandatry mandaary upon delivery')}</NormalText>
          </SectionText>
        </PolicySection>

        <PolicySection
          title={`2. ${t('SERVICE_AVAILABILITY', 'SERVICE AVAILABILITY:')}`}
          desc={t('SERVICE_AVAILABILITY_DESC', 'Our "Albee Houry" windows vary by local operating hours')}
        />

        <PolicySection
          title={`3. ${t('ORDER_PUFFILLMENT', 'ORDER PUFFILLMENT:')}`}
          desc={t('ORDER_PUFFILLMENT_DESC', 'We target 30-45 45 miniery times. Cancelation termslatucaly tems appply post-dispatch.')}
        />

        <PolicySection
          title={`4. ${t('AFFILIATE_DISCANMIER', 'AFFILIATE DISCANMIER:')}`}
          desc={t('AFFILIATE_DISCANMIER_DESC', 'Some terrsories operated by independent affillates under Bottle Runners system system.')}
        />

        <PolicySection
          title={`5. ${t('LIMITATION_OF_LIABILITY', 'LIMITATION OF LIABILITY:')}`}
          desc={t('LIMITATION_OF_LIABILITY_DESC', 'Standard protctive cluse affect for fior hational brand.')}
        />
      </ContentContainer>

      <BottomDivider />

      <BottomBar>
        <BottomText>{t('PLACE_AN_ORDER_FOR_DELIVERY', 'PLACE AN ORDER FOR DELIVERY')}</BottomText>
        <BottomBtn>{t('START_ORDER', 'START ORDER')}</BottomBtn>
      </BottomBar>
    </PolicyContainer>
  )
}
